import React from 'react';
import Tag from '../Tag';
import QuestionsProgressBar from '../../components/QuestionsProgressBar';

const LimitsUsageBox = ({
    daily_solves_limit,
    daily_solves_used,
    weekly_quizzes_limit,
    weekly_quizzes_used,
}) => {
    return (
        <div className="limits-usage-box">
            <div className="flex flex-align-center flex-between mb-32">
                <h6>Free Plan</h6>
                <Tag text={'Active'} color="green" dot={false} className="m-4" />
            </div>
            <div className="mb-20">
                <div className="flex flex-align-center flex-between mb-8">
                    <p>{weekly_quizzes_limit} Short Answer Quizzes/Week</p>
                    <span>{weekly_quizzes_used} of {weekly_quizzes_limit} is used</span>
                </div>
                <QuestionsProgressBar total={weekly_quizzes_limit} current={weekly_quizzes_used} showCount={false} />
            </div>
            <div>
                <div className="flex flex-align-center flex-between mb-8">
                    <p>{daily_solves_limit} Scans/Day</p>
                    <span>{daily_solves_used} of {daily_solves_limit} is used</span>
                </div>
                <QuestionsProgressBar total={daily_solves_limit} current={daily_solves_used} showCount={false} />
            </div>
        </div>
    );
};

export default LimitsUsageBox;
